export function userSettingsPath(): string {
  return '/settings/user'
}

export function changePasswordPath(): string {
  return '/settings/user/change-password'
}

export function mfaSettingsPath(): string {
  return '/settings/user/mfa'
}

export function mfaSecurityCheckPath(redirect?: string): string {
  if (redirect) {
    return `/settings/user/mfa/check?redirect=${encodeURIComponent(redirect)}`
  }
  return '/settings/user/mfa/check'
}
